<template>
  <div class="loginDiv">
        
        <div v-if="!isGoogle && !isSaml">
            <form ref="loginform" v-on:keyup.enter="login">
                
                <formentrystacked inputid="user" label="email" v-model="username" />
                <formentrystacked inputid="pass" inputtype="password" label="password" v-model="password" />
                
                <smallbutton @click="login()" toplabel="Login"/>
                
                <div v-if="pleaseWait">
                    <label for="" class="pleasewait">Please Wait...</label>
                </div> 
            </form>
            <div class="margin10">
                <confirm ref="confirmcancel" :showButton="paramFalse" :showLink="paramTrue"  body="Do you want to reset your password?" @yes="forgotpassword" title="Forgot Password" />
                <!-- <linkbutton @click="forgotpassword()" toplabel="forgot password"/> -->
            </div>
        </div>
            
        <!-- GOOGLE -->
        <div v-if="isGoogle">
            <googleidentity @loggedin="googleloggedin" @loginfailed="googlefailed"/>
            <!-- <googlelogin @loggedin="googleloggedin" @loginfailed="googlefailed"/> -->
        </div>
        
        
        <!-- SAML -->
        <div v-if="isSaml">
            <smallbutton toplabel="Login" @click="loginSaml"/>
        </div>


        <div class="horizFlex " v-if="allowStoreLogin">
            <input class="entryCheckbox" type="checkbox" v-model="storeLogin" >
            <label for="" class="mediumtext">Keep Me Logged In</label>
        </div>
<div v-if="responseMessage!=null" class="bottom10">
            <label class="responsemessage">{{ responseMessage }}</label>
        </div>
      <updatepassword ref="changepass" v-show="ischangepassword" :username="username" :oldpassword="oldpassword"></updatepassword>
    </div>

        
</template>

<script>
import {mapFields} from 'vuex-map-fields'

import datamethods from '../../datamethods.js'
import formentrystacked from '../controls/entry-stacked.vue'
import linkbutton from '../controls/linkbutton.vue'
import smallbutton from '../controls/button.vue'
import updatepassword from './updatepassword.vue'
import googleidentity from './googleidentity.vue'
 import confirm from '../actions/confirm.vue'
export default {
    name:'loginuser',
    mixins:[datamethods],
    components:{
        formentrystacked,
        linkbutton,
        smallbutton,
        updatepassword,
        googleidentity,
        confirm
    },
    computed:{
        ...mapFields([
            'loggedInUser',
            'loggedIn',
            'username',
            'oldpassword',
            'isReady',
            'didFailAuth',
            'token',
            'responseMessage',
            'storeLogin'
        ]),
        isSaml(){
            if(window.SAML_LOGIN==undefined){return false}
            if(window.SAML_LOGIN==''){return false}
            else{return window.SAML_LOGIN!=null}
        },
        samlUrl(){
            if(window.SAML_LOGIN==undefined){return null}
            else{return window.SAML_LOGIN}
        }

    },
    data(){
        return{
            newUserURL:window.NEW_USER_URL,
            newUserText:'Click here to create a new Account',
            password:'',

            pleaseWait:false,
            // responseMessage:'',

            ischangepassword:false,

            //GOOGLE
            isGoogle:window.GOOGLE_LOGIN!="",

            

           // token:null,
            allowStoreLogin:true,
            
            isMountedLogin:true,
            paramTrue:true,
            paramFalse:false
        }
    },
    mounted(){
    
    
  },
    methods:{
        //saml
        loginSaml(){
            //stash teh current status of allowstoretoken so we can check it on redirect
            localStorage.storeLogin = this.storeLogin

            window.onbeforeunload = null
            window.location.href=this.samlUrl
          //  window.location.replace(this.samlUrl);
        },


        prelogin(){
            console.log('pre')
            if(this.allowStoreLogin){

                //stash teh current status of allowstoretoken so we can check it on redirect
                localStorage.storeLogin = this.storeLogin

                this.token = localStorage.token
                console.log('prelogin t' + this.token)
                if(this.token==null){
                    this.setready()
                    return 
                }
                if(this.token=='' || this.token=='null'){
                    this.setready()
                    return
                }

                //now we call our login, with the token! (no username or pwd)
                this.post_login(this.token)
            }
            else{
                this.setready()
            }
        },
        setready(){
            this.isReady=true
        },
        changepassword(){
            this.ischangepassword=true
            this.$refs.changepass.ChangePassword();
        },
        async forgotpassword(){
            
            //validate
            if(this.username==""){
                this.responseMessage="Please enter your email address and click forgot password"
                return
              }
            let req = {
                email:this.username,
            }
            this.pleaseWait=true;
            this.responseMessage='';
            var response = await this.callAPI(req,'forgotpass_appurl')
            //handle response
            if(response.Successful){
                 this.responseMessage = "Please check your email for your password reset link"
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;    
        },
   
        async login(){
            this.responseMessage='';
            //validate
            if(this.username=="" || this.password==""){return}
            let req = {
                username:this.username,
                password:this.password,
            }
            var response = await this.callAPI(req,'securitylogin')
            //handle response
            if(response.Successful){
                this.post_login(response.securityInfo.token)
            }else{
                this.responseMessage = response.Message
            }
           
        },
        //GOOGLE HANDLING
        googleloggedin(token){
            this.post_login(token)
        },
        googlefailed(message){
            this.responseMessage =message
        },
        async post_login(token){
            //add to api
            this.AddTokenToAPI(token)
            this.token=token

            //store?
            console.log('store the token ' + this.storeLogin  + ' ' +  token)
            this.storeLogin = localStorage.storeLogin
            if(this.storeLogin){
                
                localStorage.token=token;
            }

            //no username/pwd
            this.responseMessage='';
            //validate
            var response = await this.callAPI(null,'badgelogin')
            //handle response
            if(response.Successful){
                console.log(response)
                this.loggedInUser= response.Person
                this.loggedIn=true
                this.didFailAuth=false
                this.$emit('loggedin')
                //this.AddUserToAPI(this.loggedInUser)
               this.setready()
            }else{
               this.loggedIn=false
                //don't show the message on the mounted login
                if(this.isMountedLogin){
                    this.isMountedLogin=false
                }else{
                    this.responseMessage = response.Message
                }
                this.setready()
            }
        }
       
    }
}
</script>

<style >

.loginDiv{
  margin-top:60px;
  grid-area: center;
  display:flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-size:large;
}
.margin10{
    margin:10px;
}
.responsemessage{
    color:red;
}
</style>


